export const THEMES = {
  DEFAULT: 'DEFAULT',
  ALTERNATIVE: 'ALTERNATIVE',
  DARK: 'DARK',
  LIGHT: 'LIGHT',
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  INDIGO: 'INDIGO',
};
